import ContractShareModal from "../ContractShareModal"
import { useState } from "react"
import { useTranslation } from "react-i18next"

const ContractSummary = ({
  summary,
  sections = [],
  sectionStatus = {},
  setShowSummary,
  onShare,
  withoutEdit = false,
}) => {
  const { t, i18n } = useTranslation()
  const currentLang = i18n.language
  const [isShareOpen, setIsShareOpen] = useState(false)

  if (!summary && (!sections || sections.length === 0)) return null

  const hasUnclearSections = Object.values(sectionStatus).some(
    (status) => status === "notUnderstood"
  )

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="flex items-center justify-between mb-4 flex-shrink-0">
        <h2 className="text-[36px] font-extrabold text-dark-default">
          {t("summary.title")}
        </h2>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto pr-1 pb-4 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
        {summary && (
          <p className="text-dark-default">
            {summary?.[currentLang.toUpperCase()] || t("summary.noSummary")}
          </p>
        )}

        {!withoutEdit && (
          <div className="mt-6">
            {!hasUnclearSections ? (
              <>
                <h3 className="text-lg font-bold text-dark-default mb-2">
                  {t("summary.feedbackTitleWellDone")} 🎉
                </h3>
                <p className="text-dark-default mb-4">
                  {t("summary.feedbackText")}
                </p>
              </>
            ) : (
              <>
                <h3 className="text-lg font-bold text-dark-default mb-2">
                  {t("summary.feedbackTitleSomePointsToLookAt")}
                </h3>
                <p className="text-dark-default mb-4">
                  {t("summary.feedbackTextSomePointsToLookAt")}
                </p>
              </>
            )}
            <div className="bg-accent-default rounded-lg p-3">
              <p className="text-sm text-dark-default">
                ℹ️ {t("summary.feedbackInfoText")}
                <span className="font-bold">
                  {" "}
                  {t("summary.feedbackInfoTextBold")}
                </span>
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="mt-4 flex flex-col gap-4 flex-shrink-0">
        {!withoutEdit && (
          <button
            onClick={() => setIsShareOpen(true)}
            className="w-full bg-success-default hover:bg-success-t-lighten-1 text-light-default px-6 py-3 rounded-xl font-semibold transition-colors duration-150 shadow-sm"
          >
            {t("share.title")}
          </button>
        )}
        <button
          onClick={() => setShowSummary(false)}
          className="w-full bg-dark-default hover:bg-black-t-lighten-1 text-light-default px-6 py-3 rounded-xl font-semibold"
        >
          {t("contract.showCards")}
        </button>
      </div>

      {!withoutEdit && (
        <ContractShareModal
          isOpen={isShareOpen}
          onClose={() => setIsShareOpen(false)}
          onShare={(hours) => {
            onShare?.(hours)
            setIsShareOpen(false)
          }}
        />
      )}
    </div>
  )
}

export default ContractSummary
